import React from 'react';
import { i18n } from 'next-i18next';
import { ThemeProvider } from '@sy/component-library';
import WrapWithProviders from '@sy/app-client/src/ssrAdapter/ssrWrapper';
import Footer from '@sy/app-client/src/ssrAdapter/components/Footer';
import LandingHeader from '@sy/app-client/src/ssrAdapter/components/LandingHeader';
import type { CacheNavigation } from '@sy/ssr-types';

import type { FeatureFlags } from '~/getServerSideProps/contextDecorators/withFeatureFlags';

import { Layout, Top, TopPadding } from './MarketingTemplate.styles';
import WithGoogleOneTap from './WithGoogleOneTap';

const MarketingTemplate = ({
	activePage,
	children,
	navigation,
	overflowVisible,
	topPadding = true,
	user,
}: Props) => (
	<WrapWithProviders i18n={i18n} user={user} withTheme={false}>
		<ThemeProvider themeName="marketing" isGlobal>
			<>
				<WithGoogleOneTap />
				<Layout overflowVisible={overflowVisible}>
					<Top>
						<LandingHeader
							activePage={activePage}
							header={navigation?.header}
						/>
						{topPadding && <TopPadding />}
						{children}
					</Top>
				</Layout>
				<Footer />
			</>
		</ThemeProvider>
	</WrapWithProviders>
);

interface Props {
	activePage?: string;
	children: React.ReactNode;
	featureFlags: FeatureFlags;
	overflowVisible?: boolean;
	navigation?: CacheNavigation | null;
	topPadding?: boolean;
	user: { email: string | null; id: string | null };
}

export default MarketingTemplate;
